import { defineMessages } from 'react-intl';

export default defineMessages({
  applicationsBlocked: {
    id: 'app.components.WeekplanShiftEvent.applicationsBlocked',
    defaultMessage: 'Applications are blocked',
  },
});
